import { Injectable } from '@angular/core';
import { Subject, Observable, of } from 'rxjs';

export interface ExternalNavigationRequest {
  targetUrl: string;
  currentRoute: string;
  resolver: (allowed: boolean) => void;
}

@Injectable({
  providedIn: 'root'
})
export class FeedbackInterceptionService {
  private externalNavSubject = new Subject<ExternalNavigationRequest>();
  public externalNavigationRequested$ = this.externalNavSubject.asObservable();

  /**
   * Request external navigation with optional feedback interception
   * @param targetUrl - The external URL or identifier (e.g., 'materials')
   * @param currentRoute - Current Angular route
   * @returns Observable<boolean> - true to allow navigation, false to block
   */
  requestExternalNavigation(
    targetUrl: string,
    currentRoute: string
  ): Observable<boolean> {
    // Only intercept if on RFQ Details page or Quote Intelligence pages
    const isRfqDetailsPage = currentRoute.includes('/supplier/supplierRfqDetails');
    const isQuoteIntelligencePage = currentRoute.includes('/buyer/quoting-data-insights') || 
                                    currentRoute.includes('/supplier/quoting-data-insights');
    
    if (!isRfqDetailsPage && !isQuoteIntelligencePage) {
      return of(true); // Allow navigation without interception
    }

    // Create Observable that will be resolved by the component
    return new Observable<boolean>(observer => {
      this.externalNavSubject.next({
        targetUrl,
        currentRoute,
        resolver: (allowed: boolean) => {
          observer.next(allowed);
          observer.complete();
        }
      });
    });
  }
}
